import React from 'react';

interface Props {
    label: string;
    onChange?: (isChecked: boolean) => void;
    isReadOnly?: boolean;
    containerClassName?: string;
    checked?: boolean;
    checkboxClassName?: string;
}

class Checkbox extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

        this.onCheckedClick = this.onCheckedClick.bind(this);
    }

    onCheckedClick(value: boolean) {
        this.setState({ checked: value });

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render(): JSX.Element {
        return (
            <div className={`display-flex align-items-center ${this.props.containerClassName || ''}`}>
                <label className='margin-0 padding-right-5px'>{this.props.label}</label>
                <input
                    className={this.props.checkboxClassName || '' }
                    type="checkbox"
                    checked={this.props.checked}
                    onChange={e => this.onCheckedClick(e.target.checked)}
                    disabled={this.props.isReadOnly} />
            </div>
        )
    }
}

export default Checkbox;